<template>
  <span
    class="field-status-icon"
    :class="ok ? 'field-status-icon--ok' : 'field-status-icon--warn'"
    aria-hidden="true"
  >
    <svg v-if="ok" viewBox="0 0 24 24">
      <path d="m5 12 5 5 9-11" />
    </svg>
    <svg v-else viewBox="0 0 24 24">
      <path d="M12 7v7" />
      <circle cx="12" cy="17.5" r="1.2" fill="#fff" stroke="none" />
    </svg>
  </span>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FieldStatusIcon',
  props: {
    ok: { type: Boolean, default: false },
  },
})
</script>

<style lang="sass" scoped>
.field-status-icon
  flex-shrink: 0
  width: 16px
  height: 16px
  border-radius: 50%
  display: inline-flex
  align-items: center
  justify-content: center

  svg
    width: 9px
    height: 9px
    stroke: #fff
    stroke-width: 3
    fill: none
    stroke-linecap: round
    stroke-linejoin: round

  &--ok
    background: #1E9E5A

  &--warn
    background: #E08A0C

    svg
      stroke-width: 2.6
</style>
